// =====================================================
// language.ts
// Intermédiaire entre l'app WEB et le service worker pour la langue.
//
// Le service worker ne peut pas utiliser AsyncStorage (React Native) —
// il tourne dans un contexte séparé de la page. La communication se
// fait donc via localStorage (pour la persistance) ET via un message
// direct au service worker actif (pour qu'il garde la langue en
// mémoire immédiatement, sans dépendre d'une lecture localStorage
// potentiellement indisponible selon le navigateur).
//
// Équivalent web de storage.ts (AsyncStorage, côté mobile).
// =====================================================

const LANGUAGE_KEY = 'harmonia_language';

// ── Sauvegarder la langue (web) ────────────────────────────────────────────────
// À appeler à chaque fois que l'utilisateur choisit ou change sa langue.
export async function saveLanguageWeb(language: string): Promise<void> {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LANGUAGE_KEY, language);
    }

    // Informer le service worker actif du changement, pour qu'il mette à
    // jour les libellés de boutons des futures notifications immédiatement.
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;
      registration.active?.postMessage({ type: 'SET_LANGUAGE', lang: language });
    }
  } catch (error) {
    console.warn('Erreur lors de la sauvegarde de la langue (web) :', error);
  }
}

// ── Récupérer la langue sauvegardée (web) ──────────────────────────────────────
export function getSavedLanguageWeb(): string | null {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(LANGUAGE_KEY);
    }
  } catch (error) {
    console.warn('Erreur lors de la récupération de la langue (web) :', error);
  }
  return null;
}
